const NativeIntersectionObserver = window.IntersectionObserver;

if (NativeIntersectionObserver) {
  window.IntersectionObserver = class StarkStickyIntersectionObserver extends NativeIntersectionObserver {
    constructor(callback, options = {}) {
      const isStickyFooterObserver = options?.rootMargin === '200px 0px 0px 0px';
      const adjustedOptions = isStickyFooterObserver
        ? { ...options, rootMargin: '0px', threshold: 0.25 }
        : options;

      super(callback, adjustedOptions);
    }
  };
}

if (!document.getElementById('stark-sticky-add-to-cart-fix')) {
  const style = document.createElement('style');
  style.id = 'stark-sticky-add-to-cart-fix';
  style.textContent = `
    .sticky-add-to-cart__bar {
      transition-duration: 0.5s !important;
    }

    @media screen and (max-width: 990px) {
      .sticky-add-to-cart__bar {
        bottom: calc(70px + env(safe-area-inset-bottom)) !important;
        width: min(600px, calc(100vw - 16px)) !important;
        max-width: calc(100vw - 16px) !important;
        box-sizing: border-box !important;
        border-radius: 8px !important;
        z-index: 95 !important;
      }
    }
  `;
  document.head.appendChild(style);
}

try {
  await import('./sticky-add-to-cart-core.js');
} finally {
  if (NativeIntersectionObserver) {
    window.IntersectionObserver = NativeIntersectionObserver;
  }
}
